import React, { Component } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';

class Pricing extends Component {
    render() {
        return (
            <div className="site-wrap">
                <Header page={'pricing'}/>
                <div className="bg-light py-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mb-0"><strong className="text-black">Pricing</strong></div>
                        </div>
                    </div>
                </div>
                <div className="site-section">
                    <div className="container">
                        <div className="row">
                            <div className='textpara col-md-12'>
                                Books and stationery pricing based on the MRP of the product.
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default Pricing;